import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/i18n/LanguageContext";
import { Reveal, SectionLabel } from "@/components/Reveal";
import { VALUES } from "@/data/content";

const EASE = [0.16, 1, 0.3, 1];

const Values = () => {
  const { lang, t } = useLang();
  return (
    <section data-testid="values-section" className="relative bg-cream text-forest py-24 sm:py-32">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-14">
        <div className="max-w-3xl mb-16">
          <SectionLabel>{t("values.label")}</SectionLabel>
          <Reveal delay={0.1}>
            <h2 className="font-display font-light tracking-tight leading-[1.02] text-4xl sm:text-5xl lg:text-6xl mt-6">
              {t("values.title")}
            </h2>
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-forest/10 border border-forest/10">
          {VALUES.map((v, i) => (
            <motion.div
              key={v.num}
              initial={{ opacity: 0, y: 26 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, ease: EASE, delay: i * 0.08 }}
              className="group relative bg-cream p-8 lg:p-10 min-h-[240px] flex flex-col justify-between hover:bg-forest-deep transition-colors duration-500"
              data-testid={`value-${v.num}`}
            >
              <span className="font-display text-5xl font-light text-gold-2 group-hover:text-gold transition-colors duration-500">
                {v.num}
              </span>
              <div>
                <h3 className="font-display text-3xl font-medium text-forest group-hover:text-cream transition-colors duration-500">
                  {v[lang].title}
                </h3>
                <p className="text-forest/65 group-hover:text-cream/70 font-light leading-relaxed mt-3 transition-colors duration-500">
                  {v[lang].text}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Values;
